'use client';
import {
  Calendar,
  Check,
  ChevronDown,
  Clock,
  Funnel,
  Info,
} from 'lucide-react';
import { useState } from 'react';
import { Tooltip } from 'react-tooltip';
import AdvancedFilters from './components/AdvancedFilters';
import BigNumber, { BigNumberProps } from './components/BigNumber';
import { Popover } from 'radix-ui';

interface BigNumbersMap {
  [key: string]: BigNumberProps[];
}

const MOCKED_BIG_NUMBERS: BigNumbersMap = {
  '2025_1': [
    {
      percentual: 24.4,
      subtitle: 'Área total desmatada no período',
      title: 'Total Desmatado',
      value: '54184.8 ha',
      variant: 'triangle_alert',
    },
    {
      percentual: 32.1,
      subtitle: '28% do total é ilegal',
      title: 'Desmatamento Ilegal',
      value: '15361.0 ha',
      variant: 'ban',
    },
    {
      percentual: 8.7,
      subtitle: '72% do total é legal',
      title: 'Desmatamento Legal',
      value: '38823.8 ha',
      variant: 'circle_check',
    },
    {
      percentual: 15.2,
      subtitle: 'Total de Alertas detectados',
      title: 'Número de Alertas',
      value: '100',
      variant: 'activity',
    },
    {
      percentual: 35.7,
      subtitle: 'Áreas com embargo ambiental ativo',
      title: 'Áreas Embargadas',
      value: '892 km²',
      variant: 'shield',
    },
    {
      percentual: 28.3,
      subtitle: 'Áreas com autuação ambiental aplicada',
      title: 'Áreas Autuadas',
      value: '1.243 km²',
      variant: 'gavel',
    },
  ],
  '2024_4': [
    {
      percentual: -18.3,
      subtitle: 'Área total desmatada no período',
      title: 'Total Desmatado',
      value: '47406.9 ha',
      variant: 'triangle_alert',
    },
    {
      percentual: -22.4,
      subtitle: '37% do total é ilegal',
      title: 'Desmatamento Ilegal',
      value: '17534.0 ha',
      variant: 'ban',
    },
    {
      percentual: -8.7,
      subtitle: '63% do total é legal',
      title: 'Desmatamento Legal',
      value: '29873.0 ha',
      variant: 'circle_check',
    },
    {
      percentual: 28.7,
      subtitle: 'Total de Alertas detectados',
      title: 'Número de Alertas',
      value: '100',
      variant: 'activity',
    },
    {
      percentual: 45.2,
      subtitle: 'Áreas com embargo ambiental ativo',
      title: 'Áreas Embargadas',
      value: '1.067 km²',
      variant: 'shield',
    },
    {
      percentual: 38.9,
      subtitle: 'Áreas com autuação ambiental aplicada',
      title: 'Áreas Autuadas',
      value: '1.489 km²',
      variant: 'gavel',
    },
  ],
  '2024_3': [
    {
      percentual: 8.4,
      subtitle: 'Área total desmatada no período',
      title: 'Total Desmatado',
      value: '47406.9 ha',
      variant: 'triangle_alert',
    },
    {
      percentual: 5.6,
      subtitle: '37% do total é ilegal',
      title: 'Desmatamento Ilegal',
      value: '17534.0 ha',
      variant: 'ban',
    },
    {
      percentual: -12.1,
      subtitle: '63% do total é legal',
      title: 'Desmatamento Legal',
      value: '29873.0 ha',
      variant: 'circle_check',
    },
    {
      percentual: 12.8,
      subtitle: 'Total de Alertas detectados',
      title: 'Número de Alertas',
      value: '100',
      variant: 'activity',
    },
    {
      percentual: 45.2,
      subtitle: 'Áreas com embargo ambiental ativo',
      title: 'Áreas Embargadas',
      value: '934 km²',
      variant: 'shield',
    },
    {
      percentual: 18.4,
      subtitle: 'Áreas com autuação ambiental aplicada',
      title: 'Áreas Autuadas',
      value: '1.489 km²',
      variant: 'gavel',
    },
  ],
  '2024_2': [
    {
      percentual: -24.4,
      subtitle: 'Área total desmatada no período',
      title: 'Total Desmatado',
      value: '54184.8 ha',
      variant: 'triangle_alert',
    },
    {
      percentual: -32.1,
      subtitle: '28% do total é ilegal',
      title: 'Desmatamento Ilegal',
      value: '15361.0 ha',
      variant: 'ban',
    },
    {
      percentual: -8.7,
      subtitle: '72% do total é legal',
      title: 'Desmatamento Legal',
      value: '38823.8 ha',
      variant: 'circle_check',
    },
    {
      percentual: 15.2,
      subtitle: 'Total de Alertas detectados',
      title: 'Número de Alertas',
      value: '100',
      variant: 'activity',
    },
    {
      percentual: 35.7,
      subtitle: 'Áreas com embargo ambiental ativo',
      title: 'Áreas Embargadas',
      value: '892 km²',
      variant: 'shield',
    },
    {
      percentual: 28.3,
      subtitle: 'Áreas com autuação ambiental aplicada',
      title: 'Áreas Autuadas',
      value: '1.243 km²',
      variant: 'gavel',
    },
  ],
  '2024_1': [
    {
      percentual: -24.4,
      subtitle: 'Área total desmatada no período',
      title: 'Total Desmatado',
      value: '54184.8 ha',
      variant: 'triangle_alert',
    },
    {
      percentual: -32.1,
      subtitle: '28% do total é ilegal',
      title: 'Desmatamento Ilegal',
      value: '15361.0 ha',
      variant: 'ban',
    },
    {
      percentual: -8.7,
      subtitle: '72% do total é legal',
      title: 'Desmatamento Legal',
      value: '38823.8 ha',
      variant: 'circle_check',
    },
    {
      percentual: 15.2,
      subtitle: 'Total de Alertas detectados',
      title: 'Número de Alertas',
      value: '100',
      variant: 'activity',
    },
    {
      percentual: 35.7,
      subtitle: 'Áreas com embargo ambiental ativo',
      title: 'Áreas Embargadas',
      value: '892 km²',
      variant: 'shield',
    },
    {
      percentual: 28.3,
      subtitle: 'Áreas com autuação ambiental aplicada',
      title: 'Áreas Autuadas',
      value: '1.243 km²',
      variant: 'gavel',
    },
  ],
  '2024': [
    {
      percentual: -24.4,
      subtitle: 'Área total desmatada no período',
      title: 'Total Desmatado',
      value: '54184.8 ha',
      variant: 'triangle_alert',
    },
    {
      percentual: -32.1,
      subtitle: '28% do total é ilegal',
      title: 'Desmatamento Ilegal',
      value: '15361.0 ha',
      variant: 'ban',
    },
    {
      percentual: -8.7,
      subtitle: '72% do total é legal',
      title: 'Desmatamento Legal',
      value: '38823.8 ha',
      variant: 'circle_check',
    },
    {
      percentual: 15.2,
      subtitle: 'Total de Alertas detectados',
      title: 'Número de Alertas',
      value: '100',
      variant: 'activity',
    },
    {
      percentual: 35.7,
      subtitle: 'Áreas com embargo ambiental ativo',
      title: 'Áreas Embargadas',
      value: '892 km²',
      variant: 'shield',
    },
    {
      percentual: 28.3,
      subtitle: 'Áreas com autuação ambiental aplicada',
      title: 'Áreas Autuadas',
      value: '1.243 km²',
      variant: 'gavel',
    },
  ],
  '2023': [
    {
      percentual: -24.4,
      subtitle: 'Área total desmatada no período',
      title: 'Total Desmatado',
      value: '54184.8 ha',
      variant: 'triangle_alert',
    },
    {
      percentual: -32.1,
      subtitle: '28% do total é ilegal',
      title: 'Desmatamento Ilegal',
      value: '15361.0 ha',
      variant: 'ban',
    },
    {
      percentual: -8.7,
      subtitle: '72% do total é legal',
      title: 'Desmatamento Legal',
      value: '38823.8 ha',
      variant: 'circle_check',
    },
    {
      percentual: 15.2,
      subtitle: 'Total de Alertas detectados',
      title: 'Número de Alertas',
      value: '100',
      variant: 'activity',
    },
    {
      percentual: 35.7,
      subtitle: 'Áreas com embargo ambiental ativo',
      title: 'Áreas Embargadas',
      value: '892 km²',
      variant: 'shield',
    },
    {
      percentual: 28.3,
      subtitle: 'Áreas com autuação ambiental aplicada',
      title: 'Áreas Autuadas',
      value: '1.243 km²',
      variant: 'gavel',
    },
  ],
};

const labels = {
  '2025_1': '1° Trimestre 2025',
  '2024_4': '4° Trimestre 2024',
  '2024_3': '3° Trimestre 2024',
  '2024_2': '2° Trimestre 2024',
  '2024_1': '1° Trimestre 2024',
  '2024': 'Ano 2024',
  '2023': 'Ano 2023',
};

const selectOptions = [
  '2025_1',
  '2024_4',
  '2024_3',
  '2024_2',
  '2024_1',
  '2024',
  '2023',
];

export default function Home() {
  const [showFilters, setShowFilters] = useState(false);
  const [selectedInterval, setSelectedInterval] = useState('2025_1');
  const [filters, setFilters] = useState({});

  const applyFilters = () => {
    setFilters({});
    setShowFilters(false);
  };

  const cleanFilters = () => {
    setFilters({});
    setShowFilters(false);
  };

  return (
    <div className="flex flex-row w-full">
      <div className="p-6 w-full">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-semibold">
              Painel de Diagnóstico do Desmatamento
            </h1>
            <div className="flex items-center gap-2 mt-2">
              <span
                data-slot="badge"
                className="justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden border-transparent bg-secondary text-secondary-foreground [a&amp;]:hover:bg-secondary/90 inline-flex items-center gap-2"
              >
                <Clock className="h-3 w-3" />
                Atualizado: 22/08/2025
              </span>
              <span
                data-tooltip-id="tooltip"
                data-tooltip-content="Fonte de dados: SEMA-MT/PLANET"
                data-tooltip-place="top"
              >
                <Info className="h-4 w-4 text-muted-foreground" />
              </span>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <Popover.Root>
              <Popover.Trigger asChild>
                <button
                  type="button"
                  role="combobox"
                  aria-controls="radix-:rft:"
                  aria-expanded="false"
                  aria-autocomplete="none"
                  dir="ltr"
                  data-state="closed"
                  data-slot="select-trigger"
                  data-size="default"
                  className="hover:cursor-pointer border-input data-[placeholder]:text-muted-foreground [&amp;_svg:not([className*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex items-center justify-between gap-2 rounded-md border border-border bg-input-background px-3 py-2 text-sm whitespace-nowrap transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&amp;_svg]:pointer-events-none [&amp;_svg]:shrink-0 [&amp;_svg:not([className*='size-'])]:size-4 w-48"
                >
                  <Calendar className="h-4 w-4 mr-2" />
                  <span data-slot="select-value">1° Trimestre 2025</span>
                  <ChevronDown className="size-4 opacity-50" />
                </button>
              </Popover.Trigger>
              <Popover.Portal>
                <Popover.Content sideOffset={4}>
                  <div className="bg-card border border-border p-1 rounded-lg w-48 shadow">
                    {selectOptions.map((key) => (
                      <Popover.Close
                        key={key}
                        onClick={() => setSelectedInterval(key)}
                        className="text-sm hover:cursor-pointer rounded-lg hover:bg-accent dark:hover:bg-accent/50 hover:text-accent-foreground p-2 w-full flex justify-between items-center"
                        aria-label="Close"
                      >
                        {labels[key as keyof typeof labels]}
                        {selectedInterval === key && (
                          <Check className="text-muted-foreground h-4 w-4" />
                        )}
                      </Popover.Close>
                    ))}
                  </div>
                </Popover.Content>
              </Popover.Portal>
            </Popover.Root>
            <button
              data-slot="button"
              className="inline-flex border-border hover:cursor-pointer items-center justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([className*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-background text-foreground hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 h-8 rounded-md px-3 has-[&gt;svg]:px-2.5 gap-2 relative"
              onClick={() => setShowFilters(!showFilters)}
            >
              <Funnel className="h-4 w-4" />
              Filtros
            </button>
          </div>
        </div>
        <div className="flex gap-4 flex-wrap">
          {MOCKED_BIG_NUMBERS[selectedInterval].map((bigNumber, index) => (
            <BigNumber key={index} {...bigNumber} />
          ))}
        </div>
        <Tooltip
          id="tooltip"
          style={{
            backgroundColor: 'var(--primary)',
            borderRadius: '8px',
            padding: '6px 8px',
            fontSize: '12px',
          }}
        />
      </div>
      {showFilters && (
        <AdvancedFilters
          applyFilters={applyFilters}
          cleanFilters={cleanFilters}
          onClose={() => {
            setShowFilters(false);
          }}
        />
      )}
    </div>
  );
}
